import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { CouponSerialNumberContainerModel } from '../../../../../../models/aggregates/erp/coupon';
import { ApiVisa, BasicApiResponseModel, Pagination, PagingResponseModel } from '../../shared';
import { BaseApiTemplateService } from '../../shared/base-api-template-service.model';
import { Core2Config } from '../../shared/core2Config';

@Injectable({ providedIn: 'root' })
export class CouponLineService extends BaseApiTemplateService<CouponSerialNumberContainerModel> {
  constructor(http: HttpClient) {
    super();
    this.apiUrl =
      Core2Config.DOMAIN_URL +
      Core2Config.TENANT_DOMAIN_URL_PREFIX +
      Core2Config.ERP_PREFIX +
      "coupons";
    this.endpoint_path =
      Core2Config.TENANT_DOMAIN_URL_PREFIX +
      Core2Config.ERP_PREFIX +
      "coupons";
    this.httpClient = http;
  }

  // call API by guid for coupon lines
  getByGuidLine(guid: string, visa: ApiVisa): Observable<BasicApiResponseModel<CouponSerialNumberContainerModel>> {
    if (this.endpoint_path && visa.api_domain_url) {
      this.apiUrl = visa.api_domain_url + this.endpoint_path;
    }
    return this.httpClient.get<BasicApiResponseModel<CouponSerialNumberContainerModel>>(
      this.apiUrl + '/lines/' + guid,
      this.getHttpHeader(visa)
    );
  }

  public editCouponLine(dtoObject: any, visa: ApiVisa): Observable<BasicApiResponseModel<any>> {
    if (this.endpoint_path && visa.api_domain_url) {
      this.apiUrl = visa.api_domain_url + this.endpoint_path;
    }
    return this.httpClient.put<BasicApiResponseModel<any>>(
      this.apiUrl + '/lines',
      dtoObject,
      this.getHttpHeader(visa)
    );
  }

  // call API by query for coupon lines
  getByCriteriaLine(pagination: Pagination, visa: ApiVisa):
    Observable<PagingResponseModel<CouponSerialNumberContainerModel>> {
    let url = this.apiUrl + '/backoffice-ep/code-name-lines/query?' + pagination.getQueryKeyValues();
    if (this.endpoint_path && visa.api_domain_url) {
      url = visa.api_domain_url + this.endpoint_path + '/backoffice-ep/code-name-lines/query?' + pagination.getQueryKeyValues();
    }
    return this.httpClient.get<PagingResponseModel<CouponSerialNumberContainerModel>>
      (url, this.getHttpHeader(visa));
  }

  // export ticket
  export(
    voucherCode: string,
    voucherName: string,
    createdDate: string,
    apiVisa: ApiVisa): Observable<Blob> {
    let params = new HttpParams()
      .set('code', voucherCode)
      .set('name', voucherName)
      .set('created_date', createdDate);
    if (this.endpoint_path && apiVisa.api_domain_url) {
      this.apiUrl = apiVisa.api_domain_url + this.endpoint_path;
    }
    return this.httpClient.get<Blob>(
      this.apiUrl + '/export/csv',
      this.getHttpHeaderBlob(apiVisa, params)
    );
  }

  // export ticket
  exportCsvNew(
    voucherCode: string,
    voucherName: string,
    dateTo: string,
    dateFrom: string,
    apiVisa: ApiVisa): Observable<Blob> {
    let params = new HttpParams()
    // .set('code', voucherCode)
    // .set('name', voucherName)
    // .set('created_date', createdDate);
    let code = '';
    let name = '';
    let created = '';
    let end = '';
    if (voucherCode !== '') {
      code = 'code=' + voucherCode + '&';
    }
    if (voucherName !== '') {
      name = 'name=' + voucherName + '&';
    }
    if (dateTo !== '') {
      created = 'startDate=' + dateFrom + '&';
    }
    if (dateFrom !== '') {
      end = 'endDate=' + dateTo + '&';
    }
    if (this.endpoint_path && apiVisa.api_domain_url) {
      this.apiUrl = apiVisa.api_domain_url + this.endpoint_path;
    }
    console.log("test:: ", code, name, created, end);
    return this.httpClient.get<Blob>(
      this.apiUrl + '/export/csv?' + code + name + created + end,
      this.getHttpHeaderBlob(apiVisa, params)
    );
  }

  isActivationPinValid(couponLineGuid: string, activationPin: string, visa: ApiVisa): Observable<BasicApiResponseModel<boolean>> {
    const pagination = new Pagination();
    pagination.conditionalCriteria = [
      {
        columnName: 'lineGuid',
        operator: '=',
        value: couponLineGuid
      },
      {
        columnName: 'activationPin',
        operator: '=',
        value: activationPin
      }
    ];

    let url = this.apiUrl + '/activation-pin-validation/public?' + pagination.getQueryKeyValues();

    if (this.endpoint_path && visa.api_domain_url) {
      url = visa.api_domain_url + this.endpoint_path + '/activation-pin-validation/public?' + pagination.getQueryKeyValues();
    }

    return this.httpClient.get<BasicApiResponseModel<boolean>>(url, this.getHttpHeader(visa));
  }

}
